import firebase from "firebase/app";

import { useTranslation } from "react-i18next";

import updateOrganization from "astrid-firestore/src/api/organizations/updateOrganization";

export default function useDistributionArgsDropdownOptions({ publisher, setOpenEdit }) {
	const { t } = useTranslation();

	return (data) => {
		return [
			{
				text: t("edit", "Edit"),
				action: () => {
					setOpenEdit(data);
				},
			},
			{
				text: t("remove", "Remove"),
				action: () => {
					return updateOrganization(firebase, publisher.ref, {
						[`distribution.channels.${data.channelId}.actions.${data.action}`]:
							firebase.firestore.FieldValue.delete(),
					});
				},
			},
		];
	};
}
